/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { bool, func, object } from 'prop-types';
import { makeStyles, Box } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
    Close, Minimize,
} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    FeedbackContainer: {
        position: 'fixed',
        bottom: '100px',
        minHeight: '320px',
        right: '110px',
        zIndex: 9999,
        boxShadow: `0 2px 1px -1px ${theme.palette.cms?.primary || theme.palette.colorPrimary}, 0 1px 1px 0 ${theme.palette.cms?.primary || theme.palette.colorPrimary}, 0 1px 3px 0 ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        borderRadius: '2px',
        backgroundColor: 'white',
        '& label': {
            color: `${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        },
        display: (props) => (props.feedbackMinimized ? 'none' : 'flex'),
        alignItems: 'end',
        flexDirection: 'column',
    },
    hidden: {
        visibility: 'hidden',
    },
    qualtricsFeedbackContainer: {
        zIndex: 9999,
        '& div:not(.status-container)': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingRight: '10px',
            paddingLeft: '5px',
            paddingBottom: '1px',
        },
    },
    statusContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '24px',
    },
    statusText: {
        paddingTop: '15px',
    },
    loadingContainer: {
        zIndex: 100,
    },
    headerActionButton: {
        border: 0,
        backgroundColor: 'transparent',
        padding: 0,
        outline: 'none',
        cursor: 'pointer',
    },
    headerBox: {
        paddingRight: '15px',
        paddingTop: '10px',
        paddingBottom: '30px',
    },

}));

const Feedback = ({
    open,
    setFeedbackOpen,
    feedbackMinimized,
    setFeedbackMinimized,
    setSurveyFetched,
    feedbackRef,
    setIsFeedbackOpened,
}) => {
    const {
        FeedbackContainer, hidden, statusContainer, qualtricsFeedbackContainer, headerActionButton, headerBox,
    } = useStyles({ feedbackMinimized });
    return ((
        <div ref={feedbackRef}>
            <div className={`${qualtricsFeedbackContainer} ${FeedbackContainer} ${!open ? hidden : ''}`}>
                <Box className={headerBox}>
                    <button
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            setFeedbackMinimized(!feedbackMinimized);
                            setFeedbackOpen(false);
                        }}
                        className={headerActionButton}
                    >
                        <Minimize fontSize="small" />
                    </button>
                    <button
                        type="button"
                        onClick={() => {
                            setFeedbackOpen(false);
                            setSurveyFetched(false);
                            setIsFeedbackOpened(false);
                        }}
                        className={headerActionButton}
                    >
                        <Close fontSize="small" />
                    </button>
                </Box>
                <div id="qualtrics-feedback-button" data-testid="qualtrics-feedback-button" className={` ${!open ? hidden : ''}`}>
                    <div className={`${statusContainer} status-container`}>
                        <CircularProgress size={24} />
                    </div>
                </div>
            </div>
        </div>
    )
    );
};

Feedback.propTypes = {
    open: bool.isRequired,
    setFeedbackOpen: func.isRequired,
    feedbackMinimized: bool.isRequired,
    setFeedbackMinimized: func.isRequired,
    setSurveyFetched: func.isRequired,
    feedbackRef: object.isRequired,
    setIsFeedbackOpened: func.isRequired,
};

export default Feedback;
